interface PropsType {
  text?: string
  size?: number
}

export default function Loading({ text = 'Loading', size = 24 }: PropsType) {
  return (
    <div className="flex items-center">
      <svg
        className="mr-2 animate-spin with-icon_icon__MHUeb"
        fill="none"
        height={size}
        shapeRendering="geometricPrecision"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        viewBox="0 0 24 24"
        width={size}
      >
        <path d="M12 2v4" />
        <path d="M12 18v4" />
        <path d="M4.93 4.93l2.83 2.83" />
        <path d="M16.24 16.24l2.83 2.83" />
        <path d="M2 12h4" />
        <path d="M18 12h4" />
        <path d="M4.93 19.07l2.83-2.83" />
        <path d="M16.24 7.76l2.83-2.83" />
      </svg>
      {text}
    </div>
  )
}
